// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"320c8836","453":"a7307bbe"}[chunkId] + ".chunk.js";
};